module.exports = __webpack_public_path__ + "static/media/机组00_03.dfb6a4d4.png";